const homePath = '/homefeeds';
export const getHome = `${homePath}/cards`;
export const postHome = `${homePath}/cards`;
export const updateCardPrivacy = (id: number) => `${homePath}/cards/${id}/privacy`;
export const updateCardStatus = (id: number) => `${homePath}/cards/${id}/activation`;
